import { Nullable } from '@internal-libraries/kheops-ui-lib'
import HospitalRoom from './ClvrHospitalRoom'
import { BedType } from '../Types/BedType'
import { BedDto } from '../Types/BedDto'

export default class ClvrBed {
    public id: Nullable<number> = null
    public hospitalRoomId: Nullable<number> = null
    public name = ''

    public hospitalRoom?: HospitalRoom

    public constructor(data?: BedType) {
        if (data) {
            Object.assign(this, data)
        }
    }

    public toDto(): BedDto {
        return {
            lit_id: this.id,
            nom: this.name,
            chambre_id: this.hospitalRoomId,
            _ref_chambre: this.hospitalRoom,
        }
    }
}
